if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) {
          if (this.dataset.zoomImageId) {
            $(this.dataset.zoomImageId).elevateZoom({
              cursor: 'pointer',
              scrollZoom: true,
              loadingIcon: "//cdn.shopify.com/s/files/1/1978/9859/t/149/assets/loading.gif?v=74321011833449561481666168467"
            })
          }
          return;
        }

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, mediaToSwitch
              .querySelector('button')));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        console.log(this.dataset.zoomImageId);
        if (this.dataset.zoomImageId) {
          // console.log(this.elements.thumbnails.querySelector(".thumbnail-list").getAttribute("id"),this.dataset.zoomImageId);
          $(this.dataset.zoomImageId).elevateZoom({
            cursor: 'pointer',
            scrollZoom: true,
            gallery: this.elements.thumbnails.querySelector(".thumbnail-list").getAttribute("id"),
            galleryActiveClass: "active",
            loadingIcon: "//cdn.shopify.com/s/files/1/1978/9859/t/149/assets/loading.gif?v=74321011833449561481666168467"
          })
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend, button) {
        console.log(button, mediaId);
        // if(button) {
        //   this.querySelectorAll(".thumbnail-list__item").forEach(item => item.classList.remove("active"));

        //   button.closest(".thumbnail-list__item")?.classList.add("active");
        // }
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (this.dataset.zoomImageId) {

          let zoomImage = this.querySelector(this.dataset.zoomImageId);
          // console.log(zoomImage, this.dataset.zoomImageId, mediaId);
          if (zoomImage) {
            zoomImage.setAttribute("src", activeMedia?.dataset.image);
            // zoomImage.setAttribute("data-zoom-image", button?.closest(".thumbnail-list__item")?.dataset.zoomImage);
            console.log("button?.closest(.thumbnail-list__item)?.dataset.image", button?.closest(".thumbnail-list__item")?.dataset.image);
          }
        }
        if (this.elements.thumbnails) {
          this.elements.thumbnails.querySelectorAll(".thumbnail-list__item").forEach((element) => {
            element.classList.remove("active");
          })
          this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`).classList.add('active');

          // 判断是否是视频，是则隐藏 Zoom，显示原本的 Viewer
          if (this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`).dataset.mediaType != "image") {
            this.elements.viewer.classList.add("gallery-viewer-active");

            document.querySelector('[id^="GalleryZoomViewer-"]').style.display = "none";

          } else {
            if (this.elements.viewer.classList.contains("gallery-viewer-active")) {
              this.elements.viewer.classList.remove("gallery-viewer-active");
            }
            document.querySelector('[id^="GalleryZoomViewer-"]').style.display = "block";

          };
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        if (prepend) {
          activeMedia.parentElement.prepend(activeMedia);
          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.prepend(activeThumbnail);
          }
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
            activeMedia.scrollIntoView({ behavior: 'smooth' });
          }
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        const zoomImage = this.querySelector('.gallery-zoom-viewer');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
        if (zoomImage) {
          const image = zoomImage.querySelector('.product__media img');
          if (image) {
            image.src = image.src;
            image.removeAttribute('srcset');
          }
        }
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
